/* TEXTILE PIONEERS – Bundle-kampagne
   Når man klikker "Kontakt os" under en pris-boks, forudvælges den
   pågældende bundle og det pågældende antal i kontaktformularen. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-tp-bundle]');
  if (!link) return;

  var campaign = link.closest('.tp-campaign');
  if (!campaign) return;

  var bundleValue = link.getAttribute('data-tp-bundle');
  var antalValue = link.getAttribute('data-tp-antal');

  setSelectValue(campaign.querySelector('select[name="contact[interesse]"]'), bundleValue);
  setSelectValue(campaign.querySelector('select[name="contact[antal]"]'), normalizeAntal(antalValue));
});

function setSelectValue(select, value) {
  if (!select || !value) return;
  var option = Array.from(select.options).find(function (o) {
    return o.value === value || o.text === value;
  });
  if (!option) {
    option = document.createElement('option');
    option.value = value;
    option.text = value;
    select.appendChild(option);
  }
  select.value = value;
}

function normalizeAntal(label) {
  // Gør "20 STK." til "20 stk." så det matcher formularens faste valgmuligheder.
  if (!label) return label;
  var match = label.match(/\d+/);
  return match ? match[0] + ' stk.' : label;
}